import axios from "../axios-auth";
import orginal_axios from "axios";

export const preventiveMaintenanceMachineReportService = {
  getPreventiveMaintenanceMachineReport,
  exportPreventiveMaintenanceMachineReportExcel,
  printPreventiveMaintenanceMachineReport,
};

function getPreventiveMaintenanceMachineReport(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy,
  };

  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.branchId) {
    params["branchId"] = searchParams.branchId;
  }
  if (searchParams.departmentId) {
    params["departmentId"] = searchParams.departmentId;
  }
  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.maintenanceFrequencyId) {
    params["maintenanceFrequencyId"] = searchParams.maintenanceFrequencyId;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.machineTypeIds) {
    params["machineTypeIds"] = searchParams.machineTypeIds.join();
  }

  return axios.get("/auth/preventive-maintenance-machine-reports", { params });
}

function exportPreventiveMaintenanceMachineReportExcel(searchParams) {
  let params = {}
    ;
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.branchId) {
    params["branchId"] = searchParams.branchId;
  }
  if (searchParams.departmentId) {
    params["departmentId"] = searchParams.departmentId;
  }
  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.maintenanceFrequencyId) {
    params["maintenanceFrequencyId"] = searchParams.maintenanceFrequencyId;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.machineTypeIds) {
    params["machineTypeIds"] = searchParams.machineTypeIds.join();
  }

  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/export-preventive-maintenance-machine-report-excel",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

function printPreventiveMaintenanceMachineReport(searchParams) {
  let params = {};

  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.branchId) {
    params["branchId"] = searchParams.branchId;
  }
  if (searchParams.departmentId) {
    params["departmentId"] = searchParams.departmentId;
  }
  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.maintenanceFrequencyId) {
    params["maintenanceFrequencyId"] = searchParams.maintenanceFrequencyId;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.machineTypeIds) {
    params["machineTypeIds"] = searchParams.machineTypeIds.join();
  }

  return axios.get("/auth/print-preventive-maintenance-machine-reports", { params });
}
